import { render } from "./privacy.vue?vue&type=template&id=9b620b5a"
import script from "./privacy.vue?vue&type=script&lang=js"
export * from "./privacy.vue?vue&type=script&lang=js"

import "./privacy.vue?vue&type=style&index=0&id=9b620b5a&lang=css"

import exportComponent from "/Users/ezink/Downloads/海/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__